import { createSelector } from 'redux-orm';

import orm from '../orm';

export const selectDampingCoefficientForPointSystem = createSelector(
  orm,
  (_, pointSystemId) => pointSystemId,
  ({ DampingCoefficient }, pointSystemId) => {
    if (!pointSystemId) {
      return null;
    }

    const model = DampingCoefficient.all().filter({ pointSistemId: pointSystemId }).first();
    return model ? model.ref : null;
  },
);

export const selectDampingCoefficientsForPointSystem = createSelector(
  orm,
  (_, pointSystemId) => pointSystemId,
  ({ DampingCoefficient }, pointSystemId) => {
    if (!pointSystemId) {
      return [];
    }

    return DampingCoefficient.all()
      .filter({ pointSistemId: pointSystemId })
      .orderBy('id')
      .toRefArray();
  },
);

export default {
  selectDampingCoefficientForPointSystem,
  selectDampingCoefficientsForPointSystem,
};

